import React from "react";
import PropTypes from "prop-types";
import styles from "./OverviewLossRecovery.module.css";

export default function PaginationFooter({
  page,
  totalPages,
  pageSize,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 100],
}) {
  return (
    <div className={styles.paginationFooter}>
      <div className={styles.leftSection}>
        <span className={styles.rowsLabel}>Rows per page</span>
        <select
          value={pageSize}
          onChange={(e) => onRowsPerPageChange?.(Number(e.target.value))}
          className={styles.rowsSelect}
        >
          {rowsPerPageOptions.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.rightSection}>
        <span className={styles.pageInfo}>
          Page {page} out of {totalPages}
        </span>
        <button
          type="button"
          title="Previous"
          disabled={page <= 1}
          onClick={() => onPageChange?.(page - 1)}
          className={styles.navBtn}
        >
          ‹
        </button>
        <button
          type="button"
          title="Next"
          disabled={page >= totalPages}
          onClick={() => onPageChange?.(page + 1)}
          className={styles.navBtn}
        >
          ›
        </button>
      </div>
    </div>
  );
}

PaginationFooter.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};